document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelector('.header-section');
  if (!header) return;

  var ticking = false;

  function updateHeader() {
    if (window.scrollY > 0) {
      header.classList.add('pm-header--scrolled');
    } else {
      header.classList.remove('pm-header--scrolled');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });

  updateHeader();
});
